import service from '../utils/request';

// 获取预充值订单分页列表
export const getPrechargeOrderList = (params) => {
  console.log(params);
  return service.get('/prepaid-recharge-orders/list', { params });
};

// 审核预充值订单
export const auditPrechargeOrder = (id, data) => {
  return service.post(`/prepaid-recharge-orders/${id}/audit`, null, { params: data });
}; 